@if (!AccessAllowed && CompletedLoading) {
  <div>
    <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
  </div>
}

@if (ChosenMembership) {
  <p-dialog header="Cancellation Warning" [(visible)]="showCancelWarning" [style]="{width: '50vw'}" [baseZIndex]="10000"  [modal]="true">
    <div class="field mb-4 col-12" style="text-align: center;">
      <br>
        <p>Are you sure you want to cancel this Membership ({{ChosenMembership.customer.fullName}} - {{ChosenMembership.salesid}}), Please check below for any future bookings associated with this Membership below.</p>
        <hr>
          @if (membershipbookings) {
            <p-table #BookingTable
              [value]="membershipbookings" sortField="name" [paginator]="true" [rows]="10"
              [showCurrentPageReport]="true" responsiveLayout="scroll"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
              [rowsPerPageOptions]="[10,25,50]"
              [globalFilterFields]="['membername','membershiptype']"
              responsiveLayout="scroll"
              datakey="bookingid"
              [selectionPageOnly]="true">
              <ng-template #header>
                <tr>
                  <th pSortableColumn="bookingid" width="40%">Booking ID
                    <p-sorticon [field]="bookingid"></p-sorticon>
                  </th>
                  <th pSortableColumn="startdate" width="35%">Start Date
                    <p-sorticon [field]="startdate"></p-sorticon>
                  </th>
                  <th pSortableColumn="enddate" width="15%">End Date
                    <p-sorticon [field]="enddate"></p-sorticon>
                  </th>
                </tr>
              </ng-template>
              <ng-template #body let-data>
                <tr>
                  <td>{{data.bookingid}}</td>
                  <td>{{data.startdate | date:'dd/MM/yy'}}</td>
                  <td>{{data.enddate | date:'dd/MM/yy'}}</td>
                </tr>
              </ng-template>
            </p-table>
          }
          @if (membershipbookings == null) {
            <div style="font-weight:bold;">
              There are no bookings for this Membership.
            </div>
          }
        </div>
        <ng-template #footer>
          <p-button icon="pi pi-check" label="Cancel Membership" styleClass="p-button p-button-success white-space-nowrap" (click)="cancelMembership()"></p-button>
          <p-button icon="pi pi-times" label="Close" styleClass="p-button p-button-danger" (click)="showCancelWarning=false"></p-button>
        </ng-template>
      </p-dialog>
    }

    @if (ListMemberships && AccessAllowed) {
      <div class="p-3 flex flex-column flex-auto">
        <div class="text-900 font-medium text-xl mb-3"><h3>Memberships
        </h3></div>
        <p class="m-0 mb-4 p-0 text-600 line-height-3 mr-3">
          <span class="pi pi-info-circle" style="margin-right:2px;"></span>
        </p>
        <div class="list-toolbar" style="text-align: right; margin-bottom: 20px;">
          <p-togglebutton class="p-component" [(ngModel)]="isDisabled" onLabel="Show Disabled" offLabel="Hide Disabled" offIcon="pi pi-times" onIcon="pi pi-check" [style]="{'margin-right': '10px', 'color' : 'white', 'background-color': '#EF4444', 'height': '50px'}" (click)="toggleDisabled()">
          </p-togglebutton>
          <span class="p-input-icon-left ml-auto" style="margin-right:20px; ">
            <i class="pi pi-search"></i>
            <input pInputText type="text" (input)="classTable.filterGlobal($event.target.value, 'contains')" style="height: 50px;padding-left:33px;" placeholder="Membership ID/Name" />
          </span>
        </div>
        <div class="surface-card p-4 shadow-2 border-round">
          <p-table  #classTable
            [columns]="cols"
            [value]="ListMemberships" sortField="name" [paginator]="true" [rows]="10"
            [showCurrentPageReport]="true" responsiveLayout="scroll"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            [rowsPerPageOptions]="[10,25,50]"
            [globalFilterFields]="['salesid','customer.fullName']"
            [(selection)]="selectedItems"
            responsiveLayout="scroll"
            datakey="classID"
            [selectionPageOnly]="true">
            <ng-template #caption>
              <div class="flex">
                <button
                  type="button"
                  pButton
                  pRipple
                  (click)="classTable.exportCSV()"
                  class="mr-2"
                  pTooltip="Export to CSV"
                  tooltipPosition="bottom" [iconOnly]="true"><span class="p-button-icon pi pi-file-excel" aria-hidden="true"></span></button>
                </div>
              </ng-template>
              <ng-template #header>
                <tr>
                  <th pSortableColumn="fullName" width="30%">Member Name
                    <p-sorticon [field]="fullName"></p-sorticon>
                  </th>
                  <th pSortableColumn="membershiptypeid" width="35%">Membership Type
                    <p-sorticon [field]="membershiptypeid"></p-sorticon>
                  </th>
                  <th pSortableColumn="" width="15%">Membership ID
                    <p-sorticon [field]="salesid "></p-sorticon>
                  </th>
                  <th pSortableColumn="enddate" width="10%">Expiry Date
                    <p-sorticon [field]="enddate"></p-sorticon>
                  </th>
                  <th width="5%"></th>
                  <th width="5%"></th>
                </tr>
              </ng-template>
              <ng-template #body let-data>
                <tr [ngStyle]="{'background-color': (data.disabled==true) ? '#fee' : '#ffffff'}">
                  <!-- <td>
                  <p-tablecheckbox [value]="data"></p-tablecheckbox>
                </td> -->
                <td>{{data.customer.fullName}}</td>
                <td>{{getMembershipType(data.membershiptypeid)}}</td>
                <td>{{data.salesid }}</td>
                <td>{{data.enddate | date:'dd/MM/yy'}}</td>
                <td><button pButton type="button" class="p-button-sm p-element p-ripple p-button-success p-button p-component" style="background-color: yellow o !important;" (click)="editData(data.membershipid);" i18>
                  <span class="pi pi-pencil" style="margin-right:8px;"></span>
                  <span i18n>Edit</span>
                </button></td>
                <td><button pButton type="button" class="p-button-sm p-element p-ripple p-button-danger p-button p-component" style="margin-left:-20px;width:198px;white-space:nowrap;"  (click)="disableData(data)" i18>
                  <span class="pi pi-trash" style="margin-right:8px;"></span>
                  <span i18n>Cancel Membership</span>
                </button></td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    }
